import { render, staticRenderFns } from "./ImgSwiper.vue?vue&type=template&id=caa32544&scoped=true&"
import script from "./ImgSwiper.vue?vue&type=script&lang=js&"
export * from "./ImgSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ImgSwiper.vue?vue&type=style&index=0&id=caa32544&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa32544",
  null
  
)

export default component.exports